var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3434_4543)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3434_4543",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4815 17C16.7678 17 17.0015 16.7676 16.9853 16.4817C16.8756 14.5492 16.1552 12.7208 14.9497 11.3431C13.637 9.84285 11.8565 9 10 9C8.14349 9 6.36301 9.84285 5.05025 11.3431C3.8448 12.7208 3.12441 14.5492 3.01469 16.4817C2.99846 16.7676 3.23215 17 3.51852 17V17C3.80489 17 4.03524 16.7676 4.05429 16.4818C4.16219 14.864 4.77264 13.3365 5.78355 12.1812C6.90183 10.9032 8.41853 10.1852 10 10.1852C11.5815 10.1852 13.0982 10.9032 14.2164 12.1812C15.2274 13.3365 15.8378 14.864 15.9457 16.4818C15.9648 16.7676 16.1951 17 16.4815 17V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.4815 17C16.7678 17 17.0015 16.7676 16.9853 16.4817C16.8756 14.5492 16.1552 12.7208 14.9497 11.3431C13.637 9.84285 11.8565 9 10 9C8.14349 9 6.36301 9.84285 5.05025 11.3431C3.8448 12.7208 3.12441 14.5492 3.01469 16.4817C2.99846 16.7676 3.23215 17 3.51852 17V17C3.80489 17 4.03524 16.7676 4.05429 16.4818C4.16219 14.864 4.77264 13.3365 5.78355 12.1812C6.90183 10.9032 8.41853 10.1852 10 10.1852C11.5815 10.1852 13.0982 10.9032 14.2164 12.1812C15.2274 13.3365 15.8378 14.864 15.9457 16.4818C15.9648 16.7676 16.1951 17 16.4815 17V17Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3434_4543)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 3.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3434_4543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonThin);
export default __webpack_public_path__ + "static/media/person_thin.ba0243e92dc5a385b0e2b631ac3f2b09.svg";
export { ForwardRef as ReactComponent };